<template>
    <div class="store-nav" :class="{ commerceEnabled: userData.is_authenticated }">
        <div class="breadcrumbs">
            <div class="crumb disabled" data-cy="crumb">
                <span data-ga="Breadcrumbs|1 - Shop">{{ $t('shop.shop') }}</span>
                <SvgIcons icon-holder-class="separator" icon-id="icon-page-right"></SvgIcons>
            </div>
            <div class="crumb" :class="{ disabled: isDefaultState }" data-cy="crumb">
                <span :data-ga="`Breadcrumbs|2 - ${service.service_name}`" @click="navToService()">{{
                    $t(`${service.service_name.toLowerCase().replace(' ', '')}`)
                }}</span>
                <SvgIcons icon-holder-class="separator" icon-id="icon-page-right"></SvgIcons>
            </div>
            <div
                v-if="Object.keys(category).length > 0"
                class="crumb"
                :class="{ disabled: !productCrumb }"
                data-cy="crumb"
            >
                <span :data-ga="`Breadcrumbs|3 - ${category.no}`" @click="navToCategory">{{
                    category.no === 0 ? $t(`shop.${category.name}`) : category.name
                }}</span>
                <SvgIcons v-if="productCrumb" icon-holder-class="separator" icon-id="icon-page-right"></SvgIcons>
            </div>
            <div v-if="productCrumb" class="crumb disabled" data-cy="crumb">
                <span :data-ga="`Breadcrumbs|4 - ${productCrumb}`">{{ productCrumb }}</span>
            </div>
        </div>
        <div v-if="userData.is_authenticated" class="break"></div>
        <div v-if="userData.is_authenticated" class="commerce" data-cy="store-nav-commerce">
            <span class="buy-more" data-cy="commerce-buy-more" @click="buyMoreClickHandler">{{
                $t('shop.need-more-currency', { displayCurrency })
            }}</span>
            <span class="amount">{{ currentBalance }}</span>
        </div>
    </div>
</template>

<script>
import { SvgIcons } from '@arena/toolkit';
import { mapState } from 'vuex';
import config from '@/config/environment-config';

export default {
    name: 'StoreNav',
    components: {
        SvgIcons,
    },
    props: {},
    data() {
        return {};
    },
    computed: {
        ...mapState(['service', 'userData', 'category', 'categories', 'productCrumb']),
        amount() {
            return this.userData.balance.amount;
        },
        currency() {
            return this.userData.balance.currency;
        },
        currentBalance() {
            return this.currency === 'NX'
                ? `${this.$n(this.amount)} ${this.currency}`
                : this.currency === 'TWD'
                ? `${this.$n(this.amount)} ${this.$t('shop.points')}`
                : `${this.$n(this.amount, 'currency', this.currency)}`;
        },
        isDefaultState() {
            return !this.productCrumb && this.categories.length > 0 && this.category.no === this.categories[0].no;
        },
        displayCurrency() {
            return this.currency === 'TWD' ? this.$t('shop.points') : this.currency;
        },
    },
    mounted() {},
    methods: {
        navToService() {
            if (this.isDefaultState) return;
            this.$router.push({
                name: 'service',
                params: {
                    service: this.service.service_name.toLowerCase(),
                },
            });
        },
        navToCategory() {
            if (!this.productCrumb) return;
            this.$router.push({
                name: 'product-list',
                params: {
                    service: this.service.service_name.toLowerCase(),
                    category: this.category.no,
                },
            });
        },
        buyMoreClickHandler() {
            window.location.href = `${config[process.env.NODE_ENV][environment.region].wallet}/add-balance`;
        },
    },
};
</script>

<style lang="less" scoped>
.store-nav {
    align-items: center;
    background-color: #25272f;
    display: flex;
    height: 45px;
    justify-content: space-between;
    padding: 0 60px;
    width: 100%;
    .breadcrumbs {
        cursor: default;
        display: flex;
        margin-right: 50px;
        white-space: nowrap;
        .crumb {
            color: #ccc;
            font-size: 12px;
            letter-spacing: -0.24px;
            text-transform: capitalize;
            &:not(:last-child):not(.disabled) span:hover {
                color: #fff;
                cursor: pointer;
            }
            &:not(.disabled) span:active {
                color: #4d4d4d !important;
            }
            .separator {
                height: 7px;
                margin: 0 8px;
                opacity: 0.5;
                width: 3px;
            }
            :last-child {
                color: #808080;
            }
        }
    }
    .commerce {
        .buy-more {
            color: #808080;
            font-size: 12px;
            letter-spacing: -0.12px;
            text-decoration: underline;
            cursor: pointer;
            &:hover {
                color: #ccc;
            }
            &:active {
                color: #4d4d4d;
            }
        }
        .amount {
            color: #f2b600;
            font-size: 15px;
            letter-spacing: -0.15px;
            margin-left: 15px;
        }
    }
    .break {
        background-color: #fff;
        display: none;
        height: 1px;
        opacity: 0.05;
        width: 100%;
    }
}
@media (max-width: 1024px) {
    .store-nav {
        padding: 0 30px;
    }
}
@media (max-width: 768px) {
    .store-nav {
        align-items: flex-start;
        flex-direction: column;
        &.commerceEnabled {
            height: 85px;
        }
        .breadcrumbs {
            margin: 0;
        }
        &:before,
        &:after {
            content: '';
            display: block;
        }
        padding: 0 20px;
        .break {
            display: block;
        }
    }
}
</style>
